import { render, staticRenderFns } from "./QueryBuilderForm.vue?vue&type=template&id=020d80c2"
import script from "./QueryBuilderForm.vue?vue&type=script&lang=js"
export * from "./QueryBuilderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports